import OpenLoad from 'App/Grid/Dispatch/OpenLoad'
import PrintLoad from 'App/Grid/Dispatch/PrintLoad'
import ViewComments from 'App/Grid/Dispatch/ViewComments'
import DeleteLoad from 'App/Grid/Dispatch/DeleteLoad'
import DriverInfo from 'App/Grid/Dispatch/DriverInfo'
import ChangeTruck from 'App/Grid/Dispatch/ChangeTruck'
import ChangeDriver from 'App/Grid/Dispatch/ChangeDriver'
import ChangeStatus from 'App/Grid/Dispatch/ChangeStatus'
import SendLoadToEld from 'App/Grid/Dispatch/SendLoadToEld'
import FilterByColumn from 'App/Grid/Dispatch/FilterByColumn'
import SetTruckLocation from 'App/Grid/Dispatch/SetTruckLocation'

/**
 * The collection of ContextMenuItem instances.
 *
 * @type {Array}
 */
export default [
    OpenLoad,
    PrintLoad,
    DeleteLoad,
    DriverInfo,
    ChangeTruck,
    ChangeDriver,
    ChangeStatus,
    ViewComments,
    SendLoadToEld,
    FilterByColumn,
    SetTruckLocation,
]
